import { apiRequest } from "./client";

export async function fetchAttachmentBlob(
  tabId: string,
  grievanceId: number,
  disposition: "inline" | "attachment" = "inline",
): Promise<Blob> {
  return apiRequest<Blob>(`/admin/tabs/${tabId}/attachments/${grievanceId}`, {
    query: { disposition },
    asBlob: true,
  });
}

export async function fetchAttachmentText(
  tabId: string,
  grievanceId: number,
): Promise<{ file_name: string; text: string }> {
  return apiRequest(`/admin/tabs/${tabId}/attachments/${grievanceId}/text`);
}

/** Triggers a browser download for a blob. */
export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
